import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Select } from "antd";
import { axiosErrorHandler } from "../../../../swzutils";
import DivisionResource from "./api/DivisionResource";
const DivisionSelect = ({ tenantId, disabled = false, allowMultiple = false, allowClear = true, style, value, onChange }) => {
    const [networkRequestInProgress, setNetworkRequestInProgress] = useState(false);
    const [searchTerm, setSearchTerm] = useState(undefined);
    const [divisions, setDivisions] = useState([]);
    useEffect(() => {
        loadDivisions();
    }, [tenantId, searchTerm]);
    const loadDivisions = () => {
        const searchParams = {
            tenantId,
            search: searchTerm
        };
        DivisionResource.search(searchParams, response => setDivisions(response.results), axiosErrorHandler, () => setNetworkRequestInProgress(false));
    };
    const onSelectChange = (selectedDivisionId) => {
        onChange && onChange(selectedDivisionId);
    };
    return (_jsx(Select, { loading: networkRequestInProgress, showSearch: true, mode: allowMultiple ? "multiple" : undefined, filterOption: false, disabled: disabled, allowClear: allowClear, style: style, onChange: onSelectChange, onSearch: setSearchTerm, value: value, options: divisions.map(it => {
            return {
                value: it.id,
                label: it.name
            };
        }) }));
};
export default DivisionSelect;
